/**
 * 具有权限的按钮
 */
import React from 'react';
import {Button,ConfigProvider } from 'antd';
import './index.scss'
export default class AuthButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {

    }
    render() {
        // 将此组件的参数过滤
        const {widthType,type,authKey, className, ...otherProps} = this.props;
        let buttonClassName = "gps_button_s";
        if (widthType == 1) {
            buttonClassName = "gps_button_l"
        }
        if (widthType == 2){
            buttonClassName = "gps_button_3";
        }
        buttonClassName += authKey?"": " "+"hide";
        // 合并props里的 className
        if (className) {
            buttonClassName += ` ${className}`
        }
        return (
            <ConfigProvider autoInsertSpaceInButton={false}>
                <Button type={type} className={buttonClassName} {...otherProps}/>
            </ConfigProvider>

        )
    }
}
